module.exports = __webpack_public_path__ + "img/about-us-form-left.06725b15.png";